import {useEffect, useRef, useState} from 'react'
import { motion } from "framer-motion";


import '../assets/css/homePage.css'
import LateralMenu from './LateralMenu';
import BoxComp from './BoxComp';

// var width_ = window.innerWidth;
// var height_ = window.innerHeight;

export const HomePage = ({ativaResp}) => {

  const lateralMenu = useRef()

  const [animate1, setAnimate1] = useState(false)
  const [animateOut, setAnimateOut] = useState(false)

  useEffect(()=>{
    setTimeout(()=>{setAnimate1(true)},500)
    setTimeout(()=>{setAnimateOut(true)},1000)
  })
  
    return <>
        <LateralMenu ativaResp={ativaResp} ref={lateralMenu}/>
        <div className="containerPrincipal homePage" style={{maxHeight: "100vh"}}>
        {animateOut ? <><BoxComp lateralMenu={lateralMenu}/>
        <motion.div
          className="comunidadeFundoTxt"
        animate={{ x: ['20%', '-80%'] }}
        transition={{
          repeat: Infinity,
          duration: 1000, 
          ease: 'linear', 
        }}
        >
            COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO
            • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO
            • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO
            • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO
            • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO
            • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO • COMUNIDADE SÃO PEDRO
        </motion.div></> : <></>}


        <div className="containerbemvindo">
            <div className="saopedroimg" style={animate1 ? {} : {transform: 'scale(1.7)'}}></div>
            <div className="bemVindoText">Seja Bem Vindo!</div>
            <div className="menuFloating" style={{opacity: animateOut ? '1' : '0' }}>
              <div className="optionMenu" tipooption="descobrir" onClick={()=>window.location.href = 'Sobre'}>
                <div className="imgOpt"></div> 
                <div className="textOpt">Descobrir</div></div>
              <div className="optionMenu" tipooption="pastorais" onClick={()=>window.location.href = 'PastoraisEMovimentos'}>
                <div className="imgOpt"></div> 
                <div className="textOpt">Pastorais e Movimentos</div></div>
              <div className="optionMenu" tipooption="programacao" onClick={()=>window.location.href = 'Programacao'}>
                <div className="imgOpt"></div> 
                <div className="textOpt">Programação</div></div>
              <div className="optionMenu" tipooption="liturgia" onClick={()=>window.location.href = 'LiturgiaDiaria'}>
                <div className="imgOpt"></div> 
                <div className="textOpt">Liturgia Diária</div></div>
              <div className="optionMenu" tipooption="biblia" onClick={()=>window.location.href = 'Biblia'}>
                <div className="imgOpt"></div> 
                <div className="textOpt">Bíblia</div></div>
              {/* <div className="optionMenu" tipooption="onde">
                <div className="imgOpt"></div> 
                <div className="textOpt">Onde Encontrar</div></div> */}

            </div>
        </div>

        {animateOut ? <motion.div
          className="comunidadeSloganFundoTxt"
        animate={{ x: ['20%', '-80%'] }}
        transition={{
          repeat: Infinity, 
          duration: 600,
          ease: 'linear',
        }}
        >
            CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO
            • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO
            • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO
            • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO
            • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO
            • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO • CASA DA UNIDADE, ESCOLA DA COMUNHÃO
        </motion.div> : <></>}

        </div>
    </>
}

export default HomePage;